module.exports = __webpack_public_path__ + "img/mizrachi-small.cd6e47a8.svg";